import './HourValue.css';

const hoursFormatter = new Intl.NumberFormat('nl-NL', {
  minimumFractionDigits: 1,
  maximumFractionDigits: 2,
  useGrouping: false
});

export default function HourValue({ value }) {
  const [whole, fraction] = hoursFormatter.format(value).split(',');
  return <span className="hour-value">{whole},{fraction?.length === 2
    ? <span className="hour-value-fraction">{fraction}</span>
    : fraction}</span>;
}
